// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2qq1Y","list":"PatternAutocomplete_list__328g1"};